module.exports = __webpack_public_path__ + "static/livingSpaces-d6396d045d9ff5066955aebb0ce98aba.jpg";